import React from 'react'
import './BlogDetailsPage.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faClock } from '@fortawesome/free-solid-svg-icons'
import Back_Btn from '../../Common_Component/Common_Btn/Back_Btn/Back_Btn'
import { useNavigate } from 'react-router-dom'

const BlogDetailsPages2 = () => {
    const navigate = useNavigate();
    return (
        <>
            <section className='BlogDetailsPage'>

                <div className='container'>
                    <div className='back_btn_holder'>
                        <Back_Btn btn_name="Back" onClick={() => {
                            navigate("/blogs")
                        }} />
                    </div>
                </div>

                <div className='blog_detail_banner'>

                    <div className='container-fluid p-0'>
                        <div className='banner_img_holder'>
                            <img src={"/assets/Image/Blogs/blog_details/Group 52649.png"} className='banner_img' alt="Banner" />
                        </div>
                    </div>

                    <div className='container'>
                        <div className='banner_text_holder'>

                            <div className=''>
                                <p className='banner_heading'>Profcyma Finance Company | Trusted Finance Company for Loan and Insurance</p>
                                <p className='subtext1'></p>
                            </div>

                            <div className='banner_footer'>
                                <div className='date_text_div'>
                                    <p className='date_text'>
                                        <FontAwesomeIcon icon={faCalendarDays} className='date_icon' />
                                        16-09-2025
                                    </p>
                                </div>

                                <div className='date_text_div'>
                                    <p className='date_text'>
                                        <FontAwesomeIcon icon={faClock} className='date_icon' />
                                        2 hrs ago
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className='blog_inner_img_holder'>
                        {/* <img src='\assets\Image\Blogs\blog_details\inner_blog.png' className='img' /> */}
                    </div>

                </div>

                <div className='container'>
                    <div className='blog_text_holder'>
                        <h1>Welcome to PROFCYMA Finance Company</h1>
                        <p>
                            Welcome to <strong>PROFCYMA FINANCE COMPANY</strong>, a trusted leader in the finance sector.
                            As an innovative finance company, we specialize in delivering a full spectrum of financial services
                            designed to help individuals and businesses achieve their financial goals.
                            Our team of experts is committed to providing tailored solutions and guidance to secure your financial future.
                        </p>

                        <h6>Our Loan Services</h6>
                        <p>We provide a broad range of loan options to meet every need:</p>

                        <h6>Home Loan</h6>
                        <p>
                            Realize your dream of owning a home with our customized Home Loan solutions.
                            At <strong>PROFCYMA FINANCE COMPANY</strong>, we offer easy, flexible, and competitive home loan products
                            to help you buy, build, or renovate your ideal property.
                            <strong>Interest rates for home loans starting from just 7.35%.</strong>
                        </p>

                        <h6>Gold Loan</h6>
                        <p>Instant liquidity using your gold assets as security.</p>

                        <h6>Credit Card Loan</h6>
                        <p>Quick financing solutions against your existing credit card limit.</p>

                        <h6>Car Loan</h6>
                        <p>
                            Drive home your dream car with our flexible and affordable Car Loan solutions.
                            We aim to make car ownership easy by offering competitive loan products and a streamlined application experience.
                            <strong>Interest rates for car loans starting from just 7.70%.</strong>
                        </p>

                        <h6>Personal Loan</h6>
                        <p>
                            Meet your financial needs with ease using our flexible Personal Loan.
                            Whether it’s for medical emergencies, education, wedding expenses, or travel,
                            our personal loans provide quick funding with minimal hassle.
                            <strong>Personal loan rates starting from 9.99%.</strong>
                        </p>

                        <h6>Property Loan</h6>
                        <p>Loans against property for business or personal requirements.</p>

                        <h6>Business Loan</h6>
                        <p>
                            Expand your operations with confidence using our flexible business loan solutions.
                            We understand the unique needs of entrepreneurs and established businesses alike,
                            which is why our loans come with industry-leading benefits and transparent processes.
                            <strong>Business loan rates starting at just 10%.</strong>
                        </p>

                        <h4>Documents Required for Business Loan</h4>
                        <ul>
                            <li><strong>Identity Proof:</strong> PAN card, Aadhaar card, Passport, or Voter ID.</li>
                            <li><strong>Business Proof:</strong> GST registration, trade license, business or shop license.</li>
                            <li><strong>Financial Documents:</strong> Bank statements (last 6-12 months), balance sheet, profit & loss statements.</li>
                            <li><strong>Income Tax Returns (ITR):</strong> of business and owner for last 2-3 years.</li>
                            <li><strong>Collateral Documents (if secured loan):</strong> Property deeds or asset evidence.</li>
                        </ul>

                        <h6>Macro Loan</h6>
                        <p>
                            A macro loan is a type of financing usually provided to larger businesses or economic sectors
                            to support significant growth, development, or investment projects.
                            Unlike microfinance, which helps individual entrepreneurs or small businesses,
                            macro loans target broader economic needs and aim to boost industries, job creation, and overall economic expansion.
                        </p>

                        <h6>Our Insurance Policy Options</h6>

                        <h6>Term Insurance</h6>
                        <p>
                            Term insurance is a simple and affordable way to protect your family's financial future.
                            It pays a lump sum amount if the insured person passes away during the policy term.
                        </p>

                        <h6>Term Life Insurance Policy</h6>
                        <p>
                            Secure your family's financial future with our comprehensive term life insurance policy.
                            Offering high coverage at affordable premiums, this plan provides a lump sum amount to your loved ones
                            in case of your untimely demise.
                            It helps cover expenses like daily living costs, outstanding loans, and future goals, ensuring peace of mind
                            for you and your family.
                            With flexible payout options, customizable coverage, and tax benefits, our term life insurance plans
                            are designed to protect what matters most.
                        </p>

                        <h6>Car Insurance</h6>
                        <p>
                            Protect your vehicle and yourself with our reliable car insurance plans.
                            Whether it's damage due to accidents, theft, or natural disasters, our policies cover you comprehensively,
                            keeping your financial risks minimal.
                            Along with mandatory third-party liability coverage, enjoy added benefits like zero depreciation,
                            roadside assistance, and cashless claim settlement services.
                            Drive with confidence knowing your car insurance has you covered.
                        </p>

                        <h6>Affordable Health Insurance</h6>
                        <p>
                            Prioritize your wellbeing with our affordable health insurance tailored to fit your budget and healthcare needs.
                            Enjoy coverage for hospitalization, surgery, and critical illnesses with cashless access to a vast network of hospitals.
                            Our plans offer flexible premiums, family floater options, and preventive healthcare benefits
                            so you can focus on recovery without financial worry.
                        </p>

                        <h6>Bike Insurance</h6>
                        <p>
                            Our Bike Insurance brings you complete protection for your scooter or motorbike against unforeseen damages and liabilities.
                            Tailored for urban and rural riders alike, the policy ensures peace of mind with coverage options suitable for all budgets
                            and vehicle types.
                            Benefit from hassle-free claims and comprehensive cover to keep your ride safe and secure.
                            Get instant Bike Insurance online with our easy digital application process.
                        </p>

                        <h6>Travel Insurance</h6>
                        <p>
                            Travel insurance helps protect you if something goes wrong during your trip.
                            It covers things like medical emergencies, trip cancellations, lost bags, and travel delays.
                        </p>

                        <h4>Why Get Travel Insurance?</h4>
                        <ul>
                            <li>It pays for unexpected medical bills if you get sick or hurt while traveling.</li>
                            <li>It refunds your money if you have to cancel or cut your trip short.</li>
                            <li>It covers lost or delayed luggage costs.</li>
                        </ul>

                        <h4>Types of Travel Insurance</h4>
                        <ul>
                            <li><strong>Single Trip Insurance:</strong> Covers just one trip.</li>
                            <li><strong>Annual Insurance:</strong> Covers multiple trips in a year; good if you travel often.</li>
                            <li><strong>Family Plans:</strong> Cover all family members on one policy.</li>
                        </ul>

                        <h6>Our Partners</h6>
                        <ul>
                            <li>HDFC Life Insurance</li>
                            <li>ICICI Life Insurance</li>
                            <li>KOTAK Life Insurance</li>
                            <li>AXIC Life Insurance</li>
                            <li>IDBI Life Insurance</li>
                            <li>PNB MetLife Insurance</li>
                        </ul>
                    </div>
                </div>

            </section>
        </>
    )
}

export default BlogDetailsPages2